import { useEffect } from 'react';

const GOOGLE_ADS_ID = 'AW-17949809670';

/**
 * Carrega gtag (Google Ads) uma única vez e expõe window.gtag / window.gtagSendEvent
 * para conversões com callback de navegação.
 */
const MarketingTagsInit = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.__verituxMarketingTagsLoaded) return;
    window.__verituxMarketingTagsLoaded = true;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GOOGLE_ADS_ID);

    window.gtagSendEvent = function (url, eventName = 'ads_conv_navigation') {
      const callback = function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      };
      gtag('event', eventName, {
        event_callback: callback,
        event_timeout: 2000,
      });
      return false;
    };
  }, []);

  return null;
};

export default MarketingTagsInit;
